import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Banner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}